var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 14.1429H6.25V13.5C6.25 13.1464 5.96875 12.8571 5.625 12.8571H4.375C4.03125 12.8571 3.75 13.1464 3.75 13.5V14.1429H0.625C0.28125 14.1429 0 14.4321 0 14.7857V16.0714C0 16.425 0.28125 16.7143 0.625 16.7143H3.75V17.3571C3.75 17.7107 4.03125 18 4.375 18H5.625C5.96875 18 6.25 17.7107 6.25 17.3571V16.7143H19.375C19.7188 16.7143 20 16.425 20 16.0714V14.7857C20 14.4321 19.7188 14.1429 19.375 14.1429ZM19.375 7.71429H16.25V7.07143C16.25 6.71786 15.9688 6.42857 15.625 6.42857H14.375C14.0312 6.42857 13.75 6.71786 13.75 7.07143V7.71429H0.625C0.28125 7.71429 0 8.00357 0 8.35714V9.64286C0 9.99643 0.28125 10.2857 0.625 10.2857H13.75V10.9286C13.75 11.2821 14.0312 11.5714 14.375 11.5714H15.625C15.9688 11.5714 16.25 11.2821 16.25 10.9286V10.2857H19.375C19.7188 10.2857 20 9.99643 20 9.64286V8.35714C20 8.00357 19.7188 7.71429 19.375 7.71429ZM19.375 1.28571H11.25V0.642857C11.25 0.289286 10.9688 0 10.625 0H9.375C9.03125 0 8.75 0.289286 8.75 0.642857V1.28571H0.625C0.28125 1.28571 0 1.575 0 1.92857V3.21429C0 3.56786 0.28125 3.85714 0.625 3.85714H8.75V4.5C8.75 4.85357 9.03125 5.14286 9.375 5.14286H10.625C10.9688 5.14286 11.25 4.85357 11.25 4.5V3.85714H19.375C19.7188 3.85714 20 3.56786 20 3.21429V1.92857C20 1.575 19.7188 1.28571 19.375 1.28571Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.0403947e.svg";
export { ForwardRef as ReactComponent };